// Core Modules
import { CommonModule, KeyValuePipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Input, Output, TemplateRef, ViewEncapsulation } from '@angular/core';

// External Modules
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgArrayPipesModule } from 'ngx-pipes';
import { NgxPermissionsModule } from 'ngx-permissions';

@Component({
  selector: 'app-list-view',
  templateUrl: './list-view.component.html',
  styleUrl: './list-view.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [CommonModule, KeyValuePipe, NgArrayPipesModule, NgbDropdownModule, NgClass, NgTemplateOutlet, NgxPermissionsModule],
})
export class ListViewComponent {
  // Bindings
  @Input() defaultSort!: string;
  @Input() displayLoader: boolean = false;
  @Input() headers: Record<string, any> = {};
  @Input() items?: Record<string, any>[];
  @Input() popoverContent!: TemplateRef<any>;
  @Input() settings?: any;
  @Input() template!: TemplateRef<any>;
  @Output() readonly listViewChange = new EventEmitter<Record<string, string>>();

  // Public Members
  public selectedFilter?: string;

  public callback(arg: Record<string, any>): void {
    let param: Record<string, any> = {};
    if (arg.type === 'sorting') {
      this.defaultSort = arg.element.value.name;
      arg.element.value.defaultSort = !arg.element.value.defaultSort;
      arg.element.value.active = !arg.element.value.active;
      param.type = 'sorting';
      param.key = arg.element.key;
      param.sortBy = arg.element.value.active ? 'asc' : 'desc';
    } else if (arg.type === 'link') {
      param.type = 'link';
      param.row = arg.row;
      param.column = arg.column;
    } else {
      if (arg.type === 'filter') this.selectedFilter = arg.value;
      param = arg;
    }
    this.listViewChange.emit(param);
  }
}
